document.documentElement.classList.remove('no-js');
document.addEventListener('click',function(e){const t=e.target.closest('[data-menu-toggle]');if(t){document.querySelector('[data-mobile-nav]')?.classList.toggle('is-open');t.setAttribute('aria-expanded',t.getAttribute('aria-expanded')!=='true')}});
document.addEventListener('change',function(e){if(e.target.matches('[data-variant-select]')){const option=e.target.selectedOptions[0];const form=e.target.closest('form');form.querySelector('[name="id"]').value=option.value;const price=document.querySelector('[data-product-price]');if(price&&option.dataset.price)price.textContent=option.dataset.price}});

(function(){
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  const targets=document.querySelectorAll('.section-head,.product-card,.collection-tile,.editorial-copy,.editorial-media,.story-copy,.story-media,.review-cards article,.newsletter>* ,.quote blockquote,.page-hero>*');
  targets.forEach(function(el,index){el.classList.add('motion-ready');el.style.setProperty('--motion-delay',Math.min(index%4,3)*70+'ms')});
  if(!('IntersectionObserver' in window)){targets.forEach(el=>el.classList.add('motion-in'));return}
  const observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('motion-in');observer.unobserve(entry.target)}})},{threshold:.12,rootMargin:'0px 0px -40px 0px'});
  targets.forEach(el=>observer.observe(el));
})();

(function(){
  const hero=document.querySelector('.hero-media');
  if(!hero||window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  let ticking=false;
  function move(){
    const rect=hero.getBoundingClientRect();
    if(rect.bottom>0&&rect.top<window.innerHeight){
      const shift=Math.max(-18,Math.min(18,rect.top*-.025));
      hero.style.setProperty('--hero-shift',shift+'px');
    }
    ticking=false;
  }
  window.addEventListener('scroll',function(){if(!ticking){requestAnimationFrame(move);ticking=true}},{passive:true});
  move();
})();
